import React, { useEffect, useState } from "react";
import api from "../../api";
import { useToast } from "../../components/toast/toast";
import { Button, Dropdown, Flex, Table, Tag } from "antd";
import CustomHeader from "../../components/header/CustomHeader";
import { IconArrowRight, IconPlus } from "@tabler/icons-react";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { useNavigate } from "react-router-dom";
import { capitalize, formatDateTime } from "../../utilities/utils";
import { useAuth } from "../../store/context/AuthContext";

const News = () => {
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState(null);
  const { user } = useAuth();
  const navigate = useNavigate();

  const toast = useToast();

  const fetchList = async () => {
    setIsLoading(true);
    const res = await api.get_news_list();
    // console.log("news res --->", res);

    if (res.status === 200) {
      setList(res.data.data);
    } else {
      toast(res.data?.message || "Алдаа гарлаа", "error");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchList();
  }, []);

  const submitHandler = async () => {
    const res = await api.create_draft_news(user.id || "");

    // console.log("create news --->", res);
    if (res.status === 200) {
      toast("Амжилттай үүслээ", "success");
      setShowModal(false);
      navigate(`/news/${res.data.id}`);
      //   fetchList();
    } else {
      toast(res.data?.message || "Алдаа гарлаа", "error");
    }
  };

  const deleteHandler = async (account_number) => {
    // console.log("delete news");
    // const res = await api.delete_bank({ account_number });
    // // console.log("delete res", res);
    // if (res.status === 200) {
    //   toast("Амжилттай устгагдлаа", "success");
    //   setVisible(false);
    //   fetchList();
    // } else {
    //   toast(res.data.message || "Алдаа гарлаа", "error");
    // }
  };

  const columns = [
    {
      title: "Зураг",
      dataIndex: ["image", "thumbnail"],
      key: "thumbnail",
      width: 150,
      render: (url) =>
        url ? (
          <img
            src={url}
            style={{ width: 40, height: 40, objectFit: "contain" }}
          />
        ) : (
          "-"
        ),
    },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      width: 250,
      render: (text) =>
        text ? (
          <Tag color={text === "published" ? "green" : "default"}>
            {capitalize(text === "published" ? "нийтлэгдсэн" : "ноорог")}
          </Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Гарчиг",
      dataIndex: "title",
      key: "title",
      render: (val) => val || "-",
    },
    {
      title: "Огноо",
      dataIndex: "created_at",
      key: "created_at",
      render: (val) => (val ? formatDateTime(val) : "-"), // formatDate нь date formatter util
    },
    {
      title: "Нийтлэгч",
      key: "author",
      render: (_, record) => record.Author?.UserProfile?.name || "-",
    },
    {
      title: "Үйлдэл",
      key: "action",
      width: 150,
      render: (_, record) => {
        const items = (record) => [
          {
            key: "detail",
            label: (
              <span style={{ color: "black", fontSize: "13px" }}>Засах</span>
            ),
          },
          // {
          //   key: "delete",
          //   label: (
          //     <span style={{ color: "red", fontSize: "13px" }}>Устгах</span>
          //   ),
          // },
        ];

        return (
          <Dropdown
            menu={{
              items: items(record),
              onClick: ({ key }) => {
                if (key === "delete") {
                  // console.log("Устгах:", record);
                  setSelected(record);
                  setIsDeleteModal(true);
                } else if (key === "detail") {
                  navigate(`/news/${record.id}`);
                  // console.log("detail", record);
                  //   setSelectedRecord(record);
                  //   setShowDrawer(true);
                }
              },
            }}
            trigger={["click"]}
          >
            <Button
              variant="filled"
              color="default"
              style={{ padding: "0 20px", fontSize: "12px" }}
            >
              Үйлдэл
              <IconArrowRight size={12} />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <Flex vertical>
      <CustomHeader
        title={"Мэдээний жагсаалт"}
        rightSide={
          <Button
            type="primary"
            style={{ padding: "0 30px" }}
            onClick={() => setShowModal(true)}
          >
            <IconPlus size={16} /> Мэдээ нэмэх
          </Button>
        }
      />

      <Table
        columns={columns}
        rowKey="id"
        dataSource={list}
        loading={isLoading}
      />

      {/* Мэдээ устгах */}
      <ConfirmModal
        variant="warning"
        showModal={isDeleteModal}
        setShowModal={setIsDeleteModal}
        submitHandler={() => deleteHandler(selected)}
        title="Итгэлтэй байна уу?"
        // description={"'Устгах' үйлдэл нь буцаах боломжгүйг анхаарна уу!"}
        description={
          <>
            '<span style={{ fontWeight: 700, color: "#0066cc" }}>Устгах</span>'
            үйлдэл нь буцаах боломжгүйг анхаарна уу!
          </>
        }
      />

      {/* Мэдээ нэмэх */}
      <ConfirmModal
        title="Шинэ мэдээ нэмэх үү?"
        showModal={showModal}
        setShowModal={setShowModal}
        submitHandler={submitHandler}
      />
    </Flex>
  );
};

export default News;
